var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"deal-rating"}},[(_vm.deal.is_free)?_c('div',{staticClass:"appsumo-freebie-counter-container"},[_c('FreebieCounter',{attrs:{"deal":_vm.deal}})],1):_c('div',{staticClass:"appsumo-taco-rating-container"},[_c('TacoRating',{attrs:{"deal":_vm.deal,"is-deal-card":_vm.isDealCard,"condensed":_vm.condensed}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }